import React from "react";
import BGVideo from "../../assets/Irrigation-System/Irrigation System - 5.mp4";
import TextFade from "../CustomTexts/TextFade";
import Button from "../Buttons/Button";
import TextEffect from "../../components/CustomTexts/TextEffect";

const CallToActionSection = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "75vh",
        display: "flex",
        flexDirection: "column",
        padding: "5%",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        margin: 0,
      }}
    >
      <video
        src={BGVideo}
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(255, 165, 0, 0.4)",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          margin: 0,
        }}
      >
        <TextFade animation="fade-up">
          <h1
            style={{
              fontSize: "27px",
              fontWeight: "600",
              lineHeight: "1.2",
              transition: "all 1s ease-in-out",
              letterSpacing: "-1px",
            }}
          >
            <TextEffect part3=" Upcoming" />{" "}
            <TextEffect text1="workshops" />{" "}
            <br />
            <TextEffect text1="Join " />
            <TextEffect part3=" us" /> <TextEffect text1=" now." />
          </h1>
        </TextFade>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button value="Contact Us" btnColor="bg-dark" url="/contact" />
        </div>
      </div>
    </div>
  );
};

export default CallToActionSection;
